import { createFileRoute, redirect } from "@tanstack/react-router";

import { needsOnboarding } from "@/helpers/features";
import OnboardingPage from "@/pages/OnboardingPage";

export const Route = createFileRoute("/_app/(onboarding)/onboarding")({
  beforeLoad: ({ context }) => {
    if (!needsOnboarding(context.auth)) {
      throw redirect({ to: "/" });
    }
  },
  component: () => <OnboardingPage />,
});
